import { render, staticRenderFns } from "./MoleculeEditionAssetContentEmpty.vue?vue&type=template&id=547fdf4a"
import script from "./MoleculeEditionAssetContentEmpty.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAssetContentEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports